import { render, staticRenderFns } from "./uploadVideo.vue?vue&type=template&id=d6b24464&scoped=true"
import script from "./uploadVideo.vue?vue&type=script&lang=js"
export * from "./uploadVideo.vue?vue&type=script&lang=js"
import style0 from "./uploadVideo.vue?vue&type=style&index=0&id=d6b24464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b24464",
  null
  
)

export default component.exports